webpackJsonp([1],{

/***/ "+LB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "03dp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0BXt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/demo.6c20488.png";

/***/ }),

/***/ "0sQS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Ziz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5VbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DAO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "96Ja":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "APjN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KCrL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LuuX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "M5Ib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54deb283","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("RjyN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js + 1 modules
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26523019","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]}),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){return _vm.$emit('on-click-title')}}},[_vm._t("default",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])]})],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){return _vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("0sQS")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'search'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'search'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d29452ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/search/index.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-search-box",class:{ 'vux-search-fixed':_vm.isFixed },style:({ top: _vm.isFixed ? _vm.top : '', position: _vm.fixPosition })},[_c('div',{staticClass:"weui-search-bar",class:{'weui-search-bar_focusing': !_vm.isCancel || _vm.currentValue}},[_vm._t("left"),_vm._v(" "),_c('form',{staticClass:"weui-search-bar__form",attrs:{"action":"."},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('on-submit', _vm.value)}}},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFixed && _vm.autoFixed),expression:"!isFixed && autoFixed"}],staticClass:"vux-search-mask",attrs:{"for":("search_input_" + _vm.uuid)},on:{"click":_vm.touch}}),_vm._v(" "),_c('div',{staticClass:"weui-search-bar__box"},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),((_vm.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":function($event){return _vm.onComposition($event, 'input')},"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}):((_vm.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":"radio"},domProps:{"checked":_vm._q(_vm.currentValue,null)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":function($event){return _vm.onComposition($event, 'input')},"change":function($event){_vm.currentValue=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":_vm.type},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){return _vm.onComposition($event, 'input')}]}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-icon-clear",attrs:{"href":"javascript:"},on:{"click":_vm.clear}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFocus && !_vm.value),expression:"!isFocus && !value"}],staticClass:"weui-search-bar__label",attrs:{"for":("search_input_" + _vm.uuid)}},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.placeholder || '搜索'))])])]),_vm._v(" "),_c('a',{staticClass:"weui-search-bar__cancel-btn",attrs:{"href":"javascript:"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText || '取消')+"\n    ")]),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFixed),expression:"isFixed"}],staticClass:"weui-cells vux-search_show"},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.results),function(item){return _c('div',{staticClass:"weui-cell weui-cell_access",on:{"click":function($event){return _vm.handleResultClick(item)}}},[_c('div',{staticClass:"weui-cell__bd weui-cell_primary"},[_c('p',[_vm._v(_vm._s(item.title))])])])})],2)])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var src_components_search = (search_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/search/index.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("fFU4")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  components_search,
  src_components_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_search = (search_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d7406b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}),0)])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("03dp")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f37d428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var flexbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var flexbox_staticRenderFns = []
var flexbox_esExports = { render: flexbox_render, staticRenderFns: flexbox_staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (flexbox_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function flexbox_injectStyle (ssrContext) {
  __webpack_require__("M5Ib")
}
var flexbox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flexbox___vue_template_functional__ = false
/* styles */
var flexbox___vue_styles__ = flexbox_injectStyle
/* scopeId */
var flexbox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flexbox___vue_module_identifier__ = null
var flexbox_Component = flexbox_normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  flexbox___vue_template_functional__,
  flexbox___vue_styles__,
  flexbox___vue_scopeId__,
  flexbox___vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = (flexbox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e3872a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var flexbox_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var flexbox_item_staticRenderFns = []
var flexbox_item_esExports = { render: flexbox_item_render, staticRenderFns: flexbox_item_staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (flexbox_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var flexbox_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flexbox_item___vue_template_functional__ = false
/* styles */
var flexbox_item___vue_styles__ = null
/* scopeId */
var flexbox_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flexbox_item___vue_module_identifier__ = null
var flexbox_item_Component = flexbox_item_normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  flexbox_item___vue_template_functional__,
  flexbox_item___vue_styles__,
  flexbox_item___vue_scopeId__,
  flexbox_item___vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = (flexbox_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var src_components_loading = (loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function loading_injectStyle (ssrContext) {
  __webpack_require__("lvdZ")
}
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = loading_injectStyle
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  components_loading,
  src_components_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = (loading_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js + 1 modules
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c83ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var x_dialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var x_dialog_staticRenderFns = []
var x_dialog_esExports = { render: x_dialog_render, staticRenderFns: x_dialog_staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (x_dialog_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function x_dialog_injectStyle (ssrContext) {
  __webpack_require__("7DAO")
}
var x_dialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_dialog___vue_template_functional__ = false
/* styles */
var x_dialog___vue_styles__ = x_dialog_injectStyle
/* scopeId */
var x_dialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_dialog___vue_module_identifier__ = null
var x_dialog_Component = x_dialog_normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  x_dialog___vue_template_functional__,
  x_dialog___vue_styles__,
  x_dialog___vue_scopeId__,
  x_dialog___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (x_dialog_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/utils/request.js


var request__this = this;





vue_esm["default"].use(toast["a" /* default */]);
var vm = new vue_esm["default"]();
var service = axios_default.a.create({
  baseURL: '' + "https://chaozhouhua.czql.gov.cn/qlApp" + '', // url = base url + request url
  timeout: 5000
});

service.interceptors.request.use(function (config) {

  return config;
}, function (error) {

  console.error(error);
  return promise_default.a.reject(error);
});

service.interceptors.response.use(
/**
* If you want to get http information such as headers or status
* Please return  response => response
*/

/**
* Determine the request status by custom code
* Here is just an example
* You can also judge the status by HTTP Status Code
*/
function (response) {
  var res = response.data;

  if (res && res.status !== 'SUCCESS') {
    vm.$vux.toast.show({
      type: 'text',
      position: 'middle',
      text: res.msg
    });
    return promise_default.a.reject(new Error(res.msg || 'Error'));
  } else {
    return res;
  }
}, function (error) {
  console.error('http error：' + error);
  request__this.$vux.toast.show({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
  return promise_default.a.reject(error);
});

/* harmony default export */ var request = (service);
// CONCATENATED MODULE: ./src/api/public.js


/// /////////////////////////////////////////////////////////////////////////////
/// //////////////////////////文章///////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////
// 文章列表
function public_getArticleList() {
  return request({
    url: '/public/articleList',
    method: 'POST'
  });
}

// 文章信息
function getArticleInfo(articleId, sign) {
  return request({
    url: '/public/articleInfo',
    method: 'POST',
    params: { articleId: articleId, sign: sign }
  });
}
/// /////////////////////////////////////////////////////////////////////////////
/// //////////////////////////用户///////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////
// 修改密码
function public_forgetPwd(data) {
  return request({
    url: '/public/forgetPwd',
    method: 'POST',
    data: data
  });
}
/// /////////////////////////////////////////////////////////////////////////////
/// //////////////////////////公共属性///////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////
// 公共属性
function getCommonParam(identity) {
  return request({
    url: '/public/commonParam',
    method: 'POST',
    params: { identity: identity }
  });
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/home/index.vue












/* harmony default export */ var home = ({
  name: 'HomeIndex',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    Search: vux_src_components_search,
    Swiper: vux_src_components_swiper_swiper,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Loading: vux_src_components_loading,
    XDialog: vux_src_components_x_dialog
  },
  data: function data() {
    return {
      title: '潮州侨联',

      searchResult: null,
      searchValue: '',

      swiperList: null,
      swiperIndex: 0,

      articleList: null,
      articleIndex: 0,
      userIdentity: null,

      showLoading: true,
      loadingText: '加载中',
      isFloatPic: false
    };
  },
  created: function created() {
    this.getArticleList();
  },

  methods: {
    getArticleList: function getArticleList() {
      var _this = this;

      public_getArticleList().then(function (res) {
        _this.articleList = res.data;
        _this.showLoading = false;
      });
    },
    onSwiperIndexChange: function onSwiperIndexChange(index) {
      this.swiperIndex = index;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/home/index.vue












/* harmony default export */ var components_home = ({
  name: 'HomeIndex',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    Search: vux_src_components_search,
    Swiper: vux_src_components_swiper_swiper,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Loading: vux_src_components_loading,
    XDialog: vux_src_components_x_dialog
  },
  data: function data() {
    return {
      title: '潮州侨联',

      searchResult: null,
      searchValue: '',

      swiperList: null,
      swiperIndex: 0,

      articleList: null,
      articleIndex: 0,
      userIdentity: null,

      showLoading: true,
      loadingText: '加载中',
      isFloatPic: false
    };
  },
  created: function created() {
    this.getArticleList();
  },

  methods: {
    getArticleList: function getArticleList() {
      var _this = this;

      public_getArticleList().then(function (res) {
        _this.articleList = res.data;
        _this.showLoading = false;
      });
    },
    onSwiperIndexChange: function onSwiperIndexChange(index) {
      this.swiperIndex = index;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25291202","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/index.vue
var home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('loading',{attrs:{"show":_vm.showLoading,"text":_vm.loadingText}})],1),_vm._v(" "),(_vm.showLoading === false)?_c('div',[_c('flexbox',{staticStyle:{"text-align":"center"},attrs:{"orient":"vertical"}},[_c('flexbox-item',_vm._l((_vm.articleList),function(article,i){return _c('div',{key:article.articleIndex},[_c('a',{attrs:{"href":article.url}},[_c('div',[_c('div',[_c('img',{attrs:{"src":article.topPic,"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px 10px"}},[_c('span',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v(" "+_vm._s(article.title))])])]),_vm._v(" "),(article.sTitle !== '')?_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v("       "+_vm._s(article.sTitle))]):_vm._e()]),_vm._v(" "),(i !== _vm.articleList.length -1)?_c('hr',{staticStyle:{"margin":"10px 10px 0 10px"}}):_vm._e()])}),0)],1)],1):_vm._e()])}
var home_staticRenderFns = []
var home_esExports = { render: home_render, staticRenderFns: home_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_home = (home_esExports);
// CONCATENATED MODULE: ./src/components/home/index.vue
function home_injectStyle (ssrContext) {
  __webpack_require__("APjN")
}
var home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var home___vue_template_functional__ = false
/* styles */
var home___vue_styles__ = home_injectStyle
/* scopeId */
var home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var home___vue_module_identifier__ = null
var home_Component = home_normalizeComponent(
  components_home,
  selectortype_template_index_0_src_components_home,
  home___vue_template_functional__,
  home___vue_styles__,
  home___vue_scopeId__,
  home___vue_module_identifier__
)

/* harmony default export */ var src_components_home = (home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d40071a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("uyKd")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-921916da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",function(){return [_vm._v(_vm._s(_vm.inlineDesc))]})],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]}),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("uwyH")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(router["a" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(router["a" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65737ba9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell-box/index.vue
var cell_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box weui-cell",class:_vm.className,style:(_vm.style),on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var cell_box_staticRenderFns = []
var cell_box_esExports = { render: cell_box_render, staticRenderFns: cell_box_staticRenderFns }
/* harmony default export */ var src_components_cell_box = (cell_box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell-box/index.vue
function cell_box_injectStyle (ssrContext) {
  __webpack_require__("tZYb")
}
var cell_box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell_box___vue_template_functional__ = false
/* styles */
var cell_box___vue_styles__ = cell_box_injectStyle
/* scopeId */
var cell_box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell_box___vue_module_identifier__ = null
var cell_box_Component = cell_box_normalizeComponent(
  components_cell_box,
  src_components_cell_box,
  cell_box___vue_template_functional__,
  cell_box___vue_styles__,
  cell_box___vue_scopeId__,
  cell_box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell_box = (cell_box_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e44a500","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("kAA/")
}
var tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (tabbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b138ba8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/badge/index.vue
var badge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var badge_staticRenderFns = []
var badge_esExports = { render: badge_render, staticRenderFns: badge_staticRenderFns }
/* harmony default export */ var src_components_badge = (badge_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/badge/index.vue
function badge_injectStyle (ssrContext) {
  __webpack_require__("cJYu")
}
var badge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var badge___vue_template_functional__ = false
/* styles */
var badge___vue_styles__ = badge_injectStyle
/* scopeId */
var badge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var badge___vue_module_identifier__ = null
var badge_Component = badge_normalizeComponent(
  components_badge,
  src_components_badge,
  badge___vue_template_functional__,
  badge___vue_styles__,
  badge___vue_scopeId__,
  badge___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_badge = (badge_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f54f49b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/myFooter.vue




/* harmony default export */ var myFooter = ({
  name: 'MyFooter',
  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item
  },
  data: function data() {
    return {
      buttonTitle: this.MyGlobal.title
    };
  },

  methods: {
    clickTitle: function clickTitle() {
      console.log('--do me--');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/myFooter.vue




/* harmony default export */ var common_myFooter = ({
  name: 'MyFooter',
  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item
  },
  data: function data() {
    return {
      buttonTitle: this.MyGlobal.title
    };
  },

  methods: {
    clickTitle: function clickTitle() {
      console.log('--do me--');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67feba0a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/myFooter.vue
var myFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tabbar',{staticStyle:{"position":"fixed"}},[_c('tabbar-item',[_c('span',{attrs:{"slot":"label"},on:{"click":function($event){return _vm.clickTitle()}},slot:"label"},[_vm._v(_vm._s(_vm.buttonTitle))])])],1)],1)}
var myFooter_staticRenderFns = []
var myFooter_esExports = { render: myFooter_render, staticRenderFns: myFooter_staticRenderFns }
/* harmony default export */ var components_common_myFooter = (myFooter_esExports);
// CONCATENATED MODULE: ./src/components/common/myFooter.vue
function myFooter_injectStyle (ssrContext) {
  __webpack_require__("96Ja")
}
var myFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myFooter___vue_template_functional__ = false
/* styles */
var myFooter___vue_styles__ = myFooter_injectStyle
/* scopeId */
var myFooter___vue_scopeId__ = "data-v-67feba0a"
/* moduleIdentifier (server only) */
var myFooter___vue_module_identifier__ = null
var myFooter_Component = myFooter_normalizeComponent(
  common_myFooter,
  components_common_myFooter,
  myFooter___vue_template_functional__,
  myFooter___vue_styles__,
  myFooter___vue_scopeId__,
  myFooter___vue_module_identifier__
)

/* harmony default export */ var src_components_common_myFooter = (myFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/article/content.vue










/* harmony default export */ var content = ({
  name: 'ArticleContent',
  components: {
    XHeader: vux_src_components_x_header,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Cell: vux_src_components_cell,
    CellBox: vux_src_components_cell_box,
    MyFooter: src_components_common_myFooter
  },
  data: function data() {
    return {
      title: '精彩潮州',
      id: null,
      sign: null,
      article: null,
      bottomTitle: this.MyGlobal.title
    };
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
    this.sign = this.$route.params.sign;
    this.getArticleContent();
  },

  methods: {
    goBack: function goBack() {

      this.$router.go(-1);
    },
    getArticleContent: function getArticleContent() {
      var _this = this;

      getArticleInfo(this.id, this.sign).then(function (res) {
        _this.article = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/article/content.vue










/* harmony default export */ var article_content = ({
  name: 'ArticleContent',
  components: {
    XHeader: vux_src_components_x_header,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Cell: vux_src_components_cell,
    CellBox: vux_src_components_cell_box,
    MyFooter: src_components_common_myFooter
  },
  data: function data() {
    return {
      title: '精彩潮州',
      id: null,
      sign: null,
      article: null,
      bottomTitle: this.MyGlobal.title
    };
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
    this.sign = this.$route.params.sign;
    this.getArticleContent();
  },

  methods: {
    goBack: function goBack() {

      this.$router.go(-1);
    },
    getArticleContent: function getArticleContent() {
      var _this = this;

      getArticleInfo(this.id, this.sign).then(function (res) {
        _this.article = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04de0800","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/article/content.vue
var content_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.article !== null)?_c('div',{staticClass:"content-box"},[_c('div',{staticStyle:{"margin":"10px"}},[_c('flexbox',[_c('flexbox-item',{staticStyle:{"text-align":"center"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"18px"}},[_vm._v(_vm._s(_vm.article.title))]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"10px"}},[_vm._v(_vm._s(_vm.article.sTitle))]),_vm._v(" "),_c('hr')])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px 10px 80px 10px"}},[_c('flexbox',[_c('flexbox-item',[_c('div',{staticStyle:{"width":"100%"},domProps:{"innerHTML":_vm._s(_vm.article.content)}},[_vm._v(_vm._s(_vm.article.content))])])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"30px","text-align":"center","color":"#d3d3d3"}},[_vm._v("~~到底了~~")])]):_vm._e()])}
var content_staticRenderFns = []
var content_esExports = { render: content_render, staticRenderFns: content_staticRenderFns }
/* harmony default export */ var components_article_content = (content_esExports);
// CONCATENATED MODULE: ./src/components/article/content.vue
function content_injectStyle (ssrContext) {
  __webpack_require__("cH5c")
  __webpack_require__("elgj")
}
var content_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var content___vue_template_functional__ = false
/* styles */
var content___vue_styles__ = content_injectStyle
/* scopeId */
var content___vue_scopeId__ = "data-v-04de0800"
/* moduleIdentifier (server only) */
var content___vue_module_identifier__ = null
var content_Component = content_normalizeComponent(
  article_content,
  components_article_content,
  content___vue_template_functional__,
  content___vue_styles__,
  content___vue_scopeId__,
  content___vue_module_identifier__
)

/* harmony default export */ var src_components_article_content = (content_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/company/introduce.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {
//   getCommonParam
// } from '../../api/public'

/* harmony default export */ var introduce = ({
  name: 'CompanyIntroduce',
  data: function data() {
    return {
      title: '潮州侨联',
      content: null
    };
  },
  created: function created() {
    // this.getAboutUs()
  },

  methods: {
    // getAboutUs () {
    //   getCommonParam('ABOUT_US').then(res => {
    //     this.content = res.data.content
    //   })
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/company/introduce.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {
//   getCommonParam
// } from '../../api/public'

/* harmony default export */ var company_introduce = ({
  name: 'CompanyIntroduce',
  data: function data() {
    return {
      title: '潮州侨联',
      content: null
    };
  },
  created: function created() {
    // this.getAboutUs()
  },

  methods: {
    // getAboutUs () {
    //   getCommonParam('ABOUT_US').then(res => {
    //     this.content = res.data.content
    //   })
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-119b29e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/introduce.vue
var introduce_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var introduce_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('h3',[_vm._v("关于我们")])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"20px"}},[_c('br'),_vm._v("    “潮州话 呾你知”，是一款面向全球潮州话爱好者开发的学习软件，收集了包括潮州童谣、俗语、谚语、日常用语等句子。为更好让世界各地潮人了解潮州，软件还设计了潮州文化的展示窗口，旨在帮助世界各地潮人了解潮州非遗、民俗、饮食、工艺等特色文化。\n      "),_c('br'),_vm._v("    “潮州话 呾你知”软件只作为趣味性的学习软件，不作为语言规范和研究的依据。\n      "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left"}},[_c('div',[_vm._v("项目发起单位：潮州市侨联")]),_vm._v(" "),_c('div',[_vm._v("联合承办单位：广东省侨联、潮州市人民政府"),_c('br'),_c('span',{staticStyle:{"margin-left":"110px"}},[_vm._v("新闻办公室、潮州市侨联")])]),_vm._v(" "),_c('div',[_vm._v("软件开发运维：广东远信科技实业有限公司")]),_vm._v(" "),_c('div',[_vm._v("联系方式：电话（0768-2298909）"),_c('br'),_vm._v("E-Mail：263425178@qq.com")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])}]
var introduce_esExports = { render: introduce_render, staticRenderFns: introduce_staticRenderFns }
/* harmony default export */ var components_company_introduce = (introduce_esExports);
// CONCATENATED MODULE: ./src/components/company/introduce.vue
function introduce_injectStyle (ssrContext) {
  __webpack_require__("nXJt")
}
var introduce_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var introduce___vue_template_functional__ = false
/* styles */
var introduce___vue_styles__ = introduce_injectStyle
/* scopeId */
var introduce___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var introduce___vue_module_identifier__ = null
var introduce_Component = introduce_normalizeComponent(
  company_introduce,
  components_company_introduce,
  introduce___vue_template_functional__,
  introduce___vue_styles__,
  introduce___vue_scopeId__,
  introduce___vue_module_identifier__
)

/* harmony default export */ var src_components_company_introduce = (introduce_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283ca23f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("QlJb")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js + 1 modules
var base = __webpack_require__("f6Hi");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed96448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("5VbK")
}
var icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var components_toast = __webpack_require__("rLAy");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: components_toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: components_toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8c8891a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"touchstart":function($event){return _vm.clear.apply(null, arguments)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("+LB2")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/resetPwd.vue








/* harmony default export */ var resetPwd = ({
  name: 'UserForgetPwd',
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input
  },
  data: function data() {
    return {
      title: '潮州侨联',
      newPwd: null,
      newPwd2: null,
      reqData: {
        pwd: '',
        sign: ''
      },
      count: 3,
      myH: null
    };
  },
  mounted: function mounted() {
    this.reqData.sign = this.$route.params.sign;
  },

  methods: {
    forgetPwd: function forgetPwd() {
      var _this = this;

      if (this.newPwd === null || this.newPwd === '') {
        this.$vux.toast.show({
          type: 'text',
          position: 'middle',
          text: '密码不能为空！'
        });
        return;
      }
      if (this.newPwd.length > 20 || this.newPwd.length < 8) {
        this.$vux.toast.show({
          type: 'text',
          position: 'middle',
          text: '密码长度在8-20个字符之间！'
        });
        return;
      }
      if (this.newPwd2 === null || this.newPwd2 === '') {
        this.$vux.toast.show({
          type: 'text',
          position: 'middle',
          text: '确认密码不能为空！'
        });
        return;
      }
      if (this.newPwd !== this.newPwd2) {
        this.$vux.toast.show({
          type: 'text',
          position: 'middle',
          text: '密码和确认密码不相同！'
        });
        return;
      }

      this.reqData.pwd = this.newPwd;
      public_forgetPwd(this.reqData).then(function (res) {
        if (res.status === 'SUCCESS') {
          _this.$vux.toast.show({
            type: 'text',
            position: 'middle',
            text: '重置密码成功！'
          });
          setTimeout(function () {
            _this.$router.replace('/empty');
          }, 3000);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/resetPwd.vue








/* harmony default export */ var user_resetPwd = ({
  name: 'UserForgetPwd',
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input
  },
  data: function data() {
    return {
      title: '潮州侨联',
      newPwd: null,
      newPwd2: null,
      reqData: {
        pwd: '',
        sign: ''
      },
      count: 3,
      myH: null
    };
  },
  mounted: function mounted() {
    this.reqData.sign = this.$route.params.sign;
  },

  methods: {
    forgetPwd: function forgetPwd() {
      var _this = this;

      if (this.newPwd === null || this.newPwd === '') {
        this.$vux.toast.show({
          type: 'text',
          position: 'middle',
          text: '密码不能为空！'
        });
        return;
      }
      if (this.newPwd.length > 20 || this.newPwd.length < 8) {
        this.$vux.toast.show({
          type: 'text',
          position: 'middle',
          text: '密码长度在8-20个字符之间！'
        });
        return;
      }
      if (this.newPwd2 === null || this.newPwd2 === '') {
        this.$vux.toast.show({
          type: 'text',
          position: 'middle',
          text: '确认密码不能为空！'
        });
        return;
      }
      if (this.newPwd !== this.newPwd2) {
        this.$vux.toast.show({
          type: 'text',
          position: 'middle',
          text: '密码和确认密码不相同！'
        });
        return;
      }

      this.reqData.pwd = this.newPwd;
      public_forgetPwd(this.reqData).then(function (res) {
        if (res.status === 'SUCCESS') {
          _this.$vux.toast.show({
            type: 'text',
            position: 'middle',
            text: '重置密码成功！'
          });
          setTimeout(function () {
            _this.$router.replace('/empty');
          }, 3000);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28146b99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/resetPwd.vue
var resetPwd_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_vm._m(0),_vm._v(" "),_c('flexbox',{staticStyle:{"text-align":"center"},attrs:{"orient":"vertical"}},[_c('flexbox-item',[_c('div',[_c('x-input',{attrs:{"type":"password","min":8,"max":20,"placeholder":"请输入密码"},model:{value:(_vm.newPwd),callback:function ($$v) {_vm.newPwd=$$v},expression:"newPwd"}})],1)]),_vm._v(" "),_c('flexbox-item',[_c('div',[_c('x-input',{attrs:{"type":"password","min":8,"max":20,"placeholder":"请输入确认密码"},model:{value:(_vm.newPwd2),callback:function ($$v) {_vm.newPwd2=$$v},expression:"newPwd2"}})],1)]),_vm._v(" "),_c('flexbox-item',[_c('div',[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.forgetPwd.apply(null, arguments)}}},[_vm._v("提交")])],1)])],1)],1)}
var resetPwd_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("重置密码")])])}]
var resetPwd_esExports = { render: resetPwd_render, staticRenderFns: resetPwd_staticRenderFns }
/* harmony default export */ var components_user_resetPwd = (resetPwd_esExports);
// CONCATENATED MODULE: ./src/components/user/resetPwd.vue
function resetPwd_injectStyle (ssrContext) {
  __webpack_require__("KCrL")
}
var resetPwd_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var resetPwd___vue_template_functional__ = false
/* styles */
var resetPwd___vue_styles__ = resetPwd_injectStyle
/* scopeId */
var resetPwd___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var resetPwd___vue_module_identifier__ = null
var resetPwd_Component = resetPwd_normalizeComponent(
  user_resetPwd,
  components_user_resetPwd,
  resetPwd___vue_template_functional__,
  resetPwd___vue_styles__,
  resetPwd___vue_scopeId__,
  resetPwd___vue_module_identifier__
)

/* harmony default export */ var src_components_user_resetPwd = (resetPwd_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/empty.vue
//
//
//
//
//
//

/* harmony default export */ var empty = ({
  name: 'UserEmpty',
  data: function data() {
    return {
      title: '潮州侨联'
    };
  },
  mounted: function mounted() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', this.disableBrowserBack);
  },
  destroyed: function destroyed() {
    window.removeEventListener('popstate', this.disableBrowserBack, false);
  },

  methods: {
    disableBrowserBack: function disableBrowserBack() {
      history.pushState(null, null, document.URL);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/empty.vue
//
//
//
//
//
//

/* harmony default export */ var user_empty = ({
  name: 'UserEmpty',
  data: function data() {
    return {
      title: '潮州侨联'
    };
  },
  mounted: function mounted() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', this.disableBrowserBack);
  },
  destroyed: function destroyed() {
    window.removeEventListener('popstate', this.disableBrowserBack, false);
  },

  methods: {
    disableBrowserBack: function disableBrowserBack() {
      history.pushState(null, null, document.URL);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb1563c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/empty.vue
var empty_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var empty_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("密码重置成功！"),_c('br'),_vm._v("请使用新密码登录APP！")])])])}]
var empty_esExports = { render: empty_render, staticRenderFns: empty_staticRenderFns }
/* harmony default export */ var components_user_empty = (empty_esExports);
// CONCATENATED MODULE: ./src/components/user/empty.vue
var empty_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var empty___vue_template_functional__ = false
/* styles */
var empty___vue_styles__ = null
/* scopeId */
var empty___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var empty___vue_module_identifier__ = null
var empty_Component = empty_normalizeComponent(
  user_empty,
  components_user_empty,
  empty___vue_template_functional__,
  empty___vue_styles__,
  empty___vue_scopeId__,
  empty___vue_module_identifier__
)

/* harmony default export */ var src_components_user_empty = (empty_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/home/download.vue




/* harmony default export */ var download = ({
  name: 'HomeDownload',
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  data: function data() {
    return {
      title: '潮州侨联'
    };
  },
  created: function created() {},

  methods: {
    toiOS: function toiOS() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf('micromessenger') > -1) {
        this.$alert('请点击右上角，使用默认浏览器打开', 'Tips', {
          confirmButtonText: '确定'
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/home/download.vue




/* harmony default export */ var home_download = ({
  name: 'HomeDownload',
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  data: function data() {
    return {
      title: '潮州侨联'
    };
  },
  created: function created() {},

  methods: {
    toiOS: function toiOS() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf('micromessenger') > -1) {
        this.$alert('请点击右上角，使用默认浏览器打开', 'Tips', {
          confirmButtonText: '确定'
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d01e2e58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/download.vue
var download_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-top"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"lg":12}},[_c('div',{staticStyle:{"margin":"10px","text-align":"center","padding-top":"10%","padding-bottom":"30px"}},[_c('div',[_c('img',{staticStyle:{"margin-bottom":"-10px"},attrs:{"src":__webpack_require__("ZBJ4"),"width":"40px","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#d7d7df","font-size":"20px","margin-left":"8px","letter-spacing":"5px"}},[_vm._v("\n              风韵南粤·都来学习潮州话\n            ")])]),_vm._v(" "),_c('div',{staticClass:"img-box"},[_c('a',{staticStyle:{"padding-right":"30px"},attrs:{"href":"https://appgallery.huawei.com/app/C114018157","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("QId4"),"width":"80px","alt":""}})]),_vm._v(" "),_c('a',{staticStyle:{"padding-right":"30px"},attrs:{"href":"https://apps.apple.com/cn/app/潮州话-呾你知/id6443847221","target":"_blank"},on:{"click":function($event){return _vm.toiOS()}}},[_c('img',{attrs:{"src":__webpack_require__("c9fp"),"width":"80px","alt":""}})]),_vm._v(" "),_c('a',{staticStyle:{"padding-right":"30px"},attrs:{"href":"https://play.google.com/store/apps/details?id=com.gdyuanxin.chaoshaodialect&hl=zh","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("VUc1"),"width":"80px","alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://chaozhouhua.czql.gov.cn/apk/czh_V2.0.apk","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("LuuX"),"width":"80px","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"img-box-min"},[_c('div',[_c('a',{staticStyle:{"padding-right":"30px"},attrs:{"href":"https://appgallery.huawei.com/app/C114018157","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("QId4"),"width":"80px","alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://apps.apple.com/cn/app/潮州话-呾你知/id6443847221","target":"_blank"},on:{"click":function($event){return _vm.toiOS()}}},[_c('img',{attrs:{"src":__webpack_require__("c9fp"),"width":"80px","alt":""}})])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"20px"}},[_c('a',{staticStyle:{"padding-right":"30px"},attrs:{"href":"https://play.google.com/store/apps/details?id=com.gdyuanxin.chaoshaodialect&hl=zh","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("VUc1"),"width":"80px","alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://chaozhouhua.czql.gov.cn/apk/czh_V2.0.apk","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("LuuX"),"width":"80px","alt":""}})])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"10px","font-size":"50px","color":"#ffffff"}},[_vm._v("潮州话，呾你知")])])]),_vm._v(" "),_c('el-col',{attrs:{"lg":12}},[_c('div',{staticStyle:{"text-align":"center","padding":"10px"}},[_c('img',{staticClass:"intro-pic",attrs:{"src":__webpack_require__("0BXt"),"alt":""}})])])],1)],1)}
var download_staticRenderFns = []
var download_esExports = { render: download_render, staticRenderFns: download_staticRenderFns }
/* harmony default export */ var components_home_download = (download_esExports);
// CONCATENATED MODULE: ./src/components/home/download.vue
function download_injectStyle (ssrContext) {
  __webpack_require__("UVhz")
}
var download_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var download___vue_template_functional__ = false
/* styles */
var download___vue_styles__ = download_injectStyle
/* scopeId */
var download___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var download___vue_module_identifier__ = null
var download_Component = download_normalizeComponent(
  home_download,
  components_home_download,
  download___vue_template_functional__,
  download___vue_styles__,
  download___vue_scopeId__,
  download___vue_module_identifier__
)

/* harmony default export */ var src_components_home_download = (download_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js







var routes = [{
  path: '/',
  name: 'Index',
  component: src_components_home
}, {
  path: '/index',
  name: 'HomeIndex',
  component: src_components_home
}, {
  path: '/company/introduce',
  name: 'CompanyIntroduce',
  component: src_components_company_introduce
}, {
  path: '/article/:id/:sign',
  name: 'ArticleContent',
  component: src_components_article_content
}, {
  path: '/resetPwd/:sign',
  name: 'UserResetPwd',
  component: src_components_user_resetPwd
}, {
  path: '/empty',
  name: 'UserEmpty',
  component: src_components_user_empty
}, {
  path: '/download',
  name: 'HomeDownload',
  component: src_components_home_download
}];

/* harmony default export */ var src_router = (routes);
// CONCATENATED MODULE: ./src/utils/globalConst.js
var title = '潮州侨联';
// 域名
var host = "https://chaozhouhua.czql.gov.cn/qlApp";
// 后台的授权URL
var wxAuthUrl = host + '/wx/pageAuth';
// 与后台对接校验的字符串
var wxSignature = 'Ms7uTc9sY7lwR0mf1G';
// 前端域名
var frontHost = 'https://gzh.czxqgtsy.com';

/* harmony default export */ var globalConst = ({
  title: title, host: host, wxAuthUrl: wxAuthUrl, wxSignature: wxSignature, frontHost: frontHost
});
// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./node_modules/@form-create/element-ui/dist/form-create.min.js
var form_create_min = __webpack_require__("Z4N3");
var form_create_min_default = /*#__PURE__*/__webpack_require__.n(form_create_min);

// CONCATENATED MODULE: ./src/main.js
















vue_esm["default"].use(form_create_min_default.a);

vue_esm["default"].use(element_ui_common_default.a);

vue_esm["default"].use(toast["a" /* default */]);
vue_esm["default"].prototype.MyGlobal = globalConst;
vue_esm["default"].use(vue_router_esm["a" /* default */]);

var main_router = new vue_router_esm["a" /* default */]({
  routes: src_router
});

vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  router: main_router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "QId4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "QlJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RjyN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UVhz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VUc1":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ZBJ4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.b491dbc.png";

/***/ }),

/***/ "c9fp":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIsAAACuCAYAAAAGeP56AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA39pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMC1jMDAwIDc5LjE3MWMyN2ZhYiwgMjAyMi8wOC8xNi0yMjozNTo0MSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowQUFGQjcxOTZBNTFFRDExQTc0QkI2OThCMkYxRDlBQyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpGNDc3RDk2MTNENjMxMUYwOTZDQUE4QUYyREQ1RkMwQSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpGNDc3RDk2MDNENjMxMUYwOTZDQUE4QUYyREQ1RkMwQSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVlYWQ3ODQ4LTQ3NmUtYjE0Ny1iOWNlLTA2ZDk2YjA1MWZkNyIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjAyMzFiNjFiLTU0OGMtM2U0OS05ZmEzLTY1NzA0MTU4ODEzZCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pmsc13oAAA8tSURBVHja7F1LjBTHGa7ZZW3eu5gAiw3sAH4hWGdssCJOrBVLOZpjDo6y9yjKXiJHiSIWKVEeShQs5RApl83Jx+w5FmaJLaEIC8aCyAYbMwvmuWAGsHmzm//rVG0q7eqe6sfOds9+n/SrZ7qnu/+q+uqvv/56TGVmZkYRhA+6mAWELyqtfiCWp0cOu0VeFxkU2SSyVmSlyBKRbpKuFJgWeSxyV+S2yJTIOZGTIu+JfFCpVO6nIouQpE8OIyI/EvkW87rjcVPkLyJ/FNJMeZNFiAJL8o7IAPNwweGyyJtCmIOxPouQpCLylnz8J4myYNEv8g/hwa9EuiMti1z8qRx+z/wiNH4jFubn3yCLEOU7cnhfpId5RBhaiHxPCPPuLFmEKL1yqItUmT9ECFdEXhLCXDU+y49JFCIC60TeCiyLWBUQ5qI+SRAuIC7TD6LsIlGIFlghsgdkeY15QXjguyDLduYD4YFBkGUj84HwwCaQZQ3zgfDAmi7tvBBEK6wEWRYzHwgP9IAsi5gPhA+6FCcuEQnIQhAkC0GyECQLQbIQJAtBshAEyUKQLATJQpAsBMlCkCwEQbIQJAtBshAkC0GyECQLQZAsBMlCzAEW1DKQhw8fqrt37wby9ddfB8f79+8H5x89eqQeP378jXu6u7vVokWLVE9Pj3ryySfVkiVL1LJly4IjBOdJlg4BSHH9+nU1NTWlbt26pe7du6cePHiA3a5UpVJJ/Dxz3xNPPKEWL16sVq5cqdasWaNWr14dkKiTgc18bsixr5MSBQtx9epV9cUXXwREgfWYTbAUdBqSuEhjb2UPqwPCbNiwQa1duzawSCRLgYHCA0HOnj2rms3mrBXIgxy+5MG7+vr61ObNmwPitOPdJEtC3Lx5U3388ceBRUGhdXXNn+8+PT0dkAQWZtu2baq3t5dkKYo1OXPmjPr000+D5sbX/JsmJHx0ZpK2DuGjT3OI5um5555TW7duLb2VKTVZ0IM5ceKEOnfuXMvmJuxjoIeDgkRvBgJLBLGfgd/DSkDQY4KAkHivrw9k3rtp0yY1ODgYvJdkaTPQozl27Ji6fPlyrDUxBQ5irFixQj311FOBLF26NOjRoPBwf6sCh5UASfDeO3fuqC+//DKQ27dvBwQKE81lZfr7+9Urr7wSvJdkaaNF+fDDD2OJYmo0CPLMM8+o9evXB93cvIHu+KVLl9SFCxcC4sRZGkOYXbt2ldLClI4sIEC9XleTk5ORREGhIObx7LPPBkRpR02GxQFhPvvssyC2E6fbwMCAqtVqpfNhSkcWOLMnT5509naMT7Jx40b1wgsvBE1Nu4Em6tSpU+r8+fORzjCaxR07dgROb5lQqrEhdI9Pnz7tLADTXUZX9eWXX54XogB4L94PPaCPq5cF/ZEOpIdkmaPm55NPPgmcyTBZTDAMtRXd1CIAekAf6BUmDM4hHUhPmf7QtDRkgT9w5coVpy+ADH/xxRdVtVotlM7QB3q5CIF0ID1IV1lQCpccTuHnn3/uHPwzDiOc2Tz8DQwVoFeDXhRC9lmbM+j11VdfOR1ypAfpQk+tDGNJpbAsGDHGWE/YqUVmo9eD2pu1Z4EezJEjR4JIMLrkOOI7zmfqQYhe0A96hi0M0oN0IX1shnLyVRChdZlynEPNxbySrDAWBTXcCL7jfFZAP+gZlYao9JEsKZoGREpdTq0JuOUBE1ALWwWczwPQE/q6nF2kD+kkWTLCzEcJFyRiFZgCkFfALapm51XjoSf0hd6unhHSSbLk4K+4ChBjPQidlwnQF3q7CFgGv6XQZMEor6sZME0QpEwwOrvIgnQivSRLSpjJ1a6eDkaOSze2IvpCb9d5k1aSJQNZMEAXRZYyIoosSCfJkjH2ETbZ+I7h/fka+8kK6A39XenKGtNZ8JbFZVXMDLcywqw/imqKSJaUsJdw2DXQTIUsK1kgLifXlV6SJUFvyAUzFbKMMCsck6SXZPGAPTHatiyt5swWvUcE/V2WxZVeksUT4WjnrNJd5V7PH6V/VHqLgkJPUYgKtSexKiiAixcvqhs3bgRrkxFyz2PgEc4oVj9i7fSqVavU008/7U3iKP2LPpjY0QvjMdfFrCsytRZzY7EcA0tM0wLTCrAMBTP7jaW4du1asC6oE9c4l6IZygrMS8GkI+MnmGkHR48eDQo8LVFwvz2dAc/He/C+TkahyZLVXGPo3zXhCNMBUOC4ngT4Pe7D/a6JWL7Py6N5JVlydgSjfBNDGCxU8y1g/A6/dxGl1fs6xXEvtHaueARqH3wRH+uCCUfYwcBVOCgYOKkgAJZkRBUUzuM6foffu36H5+M9PhOxzFJYlxUp+irFQpMlKkobtaWXq6bDmcX811aEwaRq10w5nG9FFDwf7/GxLGbNdJL0kiweiBpDMTsa+AA1/tVXX40lDAbw0Ly4yILzuB5HFDzfdw8Wo3vUmBfJkhKoqVFjKElC4yhILEbHiK+LMHGL2aOu4Tl4Hp6bZLMes22Hq3nKI/6zYMmCWuuq7TDjSSc4I64SZ2GSwLYoSeM10Bv6u9JV9A0MC29ZMNHZZV2SdnsNYWAJshDGEAXPSRPYc+mN9CGdtCwZyRLVFLliKL6E2blzZ2ST1IoouA/3pyFKVCzGNEEkS8bekGtStlnPk3ZND8ZykloY26Lg/jQwOrt8IKSTvaGMwIbELrLAScwSXkeB+/owto+SligA9HWtgYpKJ8mSENiI2LXWBl1ZjPpionNatOpWp+0euwA9oa9rmMBsuEyyZAR8BMyIdy37hEnPumUFCBDlw9g+Sta9bO0958JkMRsikiwZgczFtqAu041z2MMt60Rnu0lChNVIHk0PAP2gZ1QaotJXNJRiPgvac/Q+MIHJNuPIYERXsYNS1g398Pzdu3erRqMxuz8LNuPJGvswO1a5NiWE5QIRy+CvlIYsyOQtW7YEE45c1zC5afny5Zm3CAMxtm/fnqvusCjQzzUpCuRGusoyYao0k58wortu3TrnACIyHbUXVqFIgD7Qy2XxkA6kJ68tQ0iWECGwg5KrZ2Q2+cOWp9ixqQiAHtDHtbWZ6QHlsWMVyRLTc3n++ecjtwuFD4B/Bjl+/Pi8bY6D9+L90MP8O4jLj0E6yvZvIdxhOydwh+2Cgnv3kyyJazL/FYRkSWRh+H9DJEsiH4b/ZEayJAL/I5FkSWxl+O+rJEsi8H+dSZZU4D/GkyypgN6M2UIUJMLRLCuJWrhmdmoye8FhnixIYebMlnW7MpKFmFN0MQsIkoUgWQiShSBZCJKFIFkIgmQhSBaCZCFIFoJkIUgWgiBZCJKFIFkIkoUgWQiShSBIFoJkIeaOLNPMBsKXLI+YDYQvWe4xGwgPPABZbjMfCA/cBlmmmA+EB6ZAlvPMB8ID50CWfzMfCA+cAFkOMR8IDxzELgogzEWRdcwPIsq5FenvqlQqCMr9mflBxOCvwpM7wdZHYl2wQ15dpMp8IUK4IvKSkOVqMDYkH27K4fsiD5k3hAVsmvcDEAVfZgcS5cS/5PAL5g9h4bfCi3fNl/Co8x9EfqY4XrTQAT/21yK/tE86t2sUH2a3HN4RGWC+LTjg/4/fFItyMHzBOZ9FfnhEDjWR/SLXmH8LAvBbf6ed2YNOXrT0cGZmsHcnLM3rIoMim0TWiuD/WJaIdCtOoipL04K9W/FXtYibYEzwnMhJkfdEPhCS3I97QCXuDw4IomUzRBAkC0GyECQLQbIQJAtBshAEyUIkxnz+b2xVS7NSqdTtCzMzM8P6WkOujRU180TPEegpOo7Mow4LgiwgxD6RwyJDoWt7Rd4QeTtBpmEs60BKXUDK4YSFhPf9SX8G4UdTFjbSjnnQh+UZQ9Z5sADjNXWPxwx1EllG4xIo+RK+bv5Zrea4BoxJxjYc9+yJyGAULGYDfgRLFrrn22kSBGsouu3XhN8nnyfk3ETO+dar01QYU9oOyRtDrhqqr004rk247ou7J0H+gTQNl06+liWJDvK7MSsfkK5qm8qwbZZlv/V5wmqGfijyN1gKRxNlX4OeG9T/5gg32lCJTPPgi0Me/sP+tM2VIYrOF1jPvbBkneizxDVDjbD5tmpp89G0el+O0z3dFd9cqTlqaU0fD8C/cDR3hUeIKEPhTkGnObg1XTh17TeMaSvjshLmWlNI8lhnluk91SWjmnOtrCawz3wfQ+LXfH0WuaXPIrA59lmVpGF8Mv3bMe3wzxtR2umz2H5D7v7KPPsssXq10DUKo9bv6vpcXVeY+Sq/tlqWeshncXWlB7Sf0oiLy8xDhfIhQi3Kf3BYnIblx1V18zJp+W4gdz3UU8PnszE+ymsxeVs6y2IEmTpsvnvU/hEdpMtaW+Mw4Wk9UiFNb0i+j+vzjVDvx3xv6u9Nk2+dZFlMsO3vxnkVGW+RkVXtHPfKZ3j/e+MCa6FeVxKr5QvX/fsirhmLkRYjWoCz8FcQtNNN1D4daxpxWKCOsizjVs2oRlkWOHah9rovpmbWWqRxwseviHpOi/jOTAt/KJVlsQOW+vpYKC3Doff3dZplMbW8oaOT41ZvIIwJXWNMTCHKVzlkSJ9TLKSiCgJdQUZCvl4t5AMqy1J3TNfZTtSIjrOMtiAVatMBR2g/KuAX7qq/oT/f1OQ8rMPnk45AYFEIAmtbkzSPmyZY/XfcCJHbvfr7ZKfGWYa1uDBm1XRX4AzHYZeDawbdXBFRXSNNTXxbP3uPzvwx7b8UbUS7agXeDus0/MTyX5SVj+OdGmcZnYOxoZk4v8PydRq6LZ+wegx7rccMe+bRnPgsWtexUNIaVg8nHHMxqDreP+dlOR8O7v8rkNAJbVGoI1ZGzzrFDuc5PBg3NAdkGY4ii9azEe6+63vsynXAIlXTdnSt8+Ze1YkO7lw4gcPaVJuF/IfjnGLMXUFh6S7oHu34fqTN+1gLH6mVPk3tVxhMRnTzB6wu96j9Tp2muvZTTLi/V/tedrPb12nN0JxalpDJburZa77h/ppjGGIoi2UJWa2mdkqjrGC1VVfealKb4a699a4JNkN+ZJmNQ0Rlfqtna39gPCbWMaSlz4MsVU2EoYyVOOzrDVvPD+PAQiXLaNJmyKOGZvaH8hxI9HzumOXw1iLSY6xKXzvKat53UZB2edYh1CHy3Kcn6sw2fkAz52cbcmfydSKejTwZD+tsTddoqDZMBJstK265QfiC64YIb/xHgAEAbjL7zYMEyFgAAAAASUVORK5CYII="

/***/ }),

/***/ "cH5c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cJYu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "elgj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fFU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kAA/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lvdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nXJt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3Ziz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tZYb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uwyH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.30f8dd03f878dd9f2d92.js